const contactContactForm = document.querySelector(".contact-short-code");
const checkbox = document.getElementById("contact-agreement");

const contactCheckboxLabelUpdate = () => {
    if (checkbox) {
        const label = checkbox.querySelector(".wpcf7-list-item-label");
        if (label && contactContactForm?.dataset.agreement) {
            label.innerHTML = decodeHTMLEntities(
                contactContactForm.dataset.agreement
            );
        }
    }
};

// Helper function to decode HTML entities
function decodeHTMLEntities(text) {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = text;
    return textArea.value;
}
contactCheckboxLabelUpdate();
